import { Observable } from "rxjs";

import { ComponentType } from "@angular/cdk/portal";
import { MatDialogConfig } from "@angular/material/dialog";
import { IApiService } from "../models/api/i-api-service";
import { RecordsManager } from "../records-manager";
import { ICommand } from "./i-command";

type deleteConstraint<T> = {
  delete(el: T): Observable<any>;
};

export class DeleteCommand<
  T extends object & { disabled: boolean },
  S extends IApiService<T> & deleteConstraint<T>
> implements ICommand<T, S>
{
  receiver!: RecordsManager<T>;
  icon = "delete_outline";
  type: "warn" | "primary" | "accent" | undefined = "accent";
  constructor(
    public service: S,
    private dialogComponent: ComponentType<any>,
    private dialogConfig: MatDialogConfig
  ) {}
  execute(element: T) {
    this.receiver
      .showConfirmDialog(this.dialogComponent, this.dialogConfig)
      .afterClosed()
      .subscribe((isDeleteConfirmed: boolean) =>
        isDeleteConfirmed ? this.deleteItem(element) : null
      );
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  private deleteItem(element: T) {
    this.service.delete(element).subscribe((res) => {
      this.receiver.onDeleteSuccess();
    });
  }

  isDisabled(element: T) {
    return element.disabled;
  }
}
